module.exports = __webpack_public_path__ + "img/Skirt-Back-B5-Da-Fc-Ga-Ha-Ia-Gd.a1509c5f.png";